import React from 'react';
import {observer} from 'mobx-react';
import PropTypes from 'prop-types';
import {Card} from 'components/card';
import PortsCountries from 'ferries/Home/components/FerrySearchMask/PopularPortOverlay/PortsCountries';
import PopularPort from 'ferries/Home/components/FerrySearchMask/PopularPortOverlay/PopularPort';
import RecentSearches from 'ferries/Home/components/FerrySearchMask/PopularPortOverlay/RecentSearches';
import {getPopularPorts} from 'ferries/Home/components/FerrySearchMask/helperStore';

const PopularPortOverlay = ({
  isGreekDeparture, popularPorts, queries, onClickPopularPort, onChangePopularPortCountry,
  onClickQuery, translations
}) => {
  const {ports, filters} = popularPorts;
  const filteredPorts = getPopularPorts(20, isGreekDeparture)(ports);
  const nofPopularPorts = filteredPorts.length;

  return (
    <Card
      shadow
      className="position-absolute py-4 px-3"
      style={{left: 0, top: 0, zIndex: 20, marginTop: '8px', width: queries?.length > 0 ? '650px' : '100%'}}
    >
      {filters.countries.length > 1 && <PortsCountries
        showArrows
        popularPorts={popularPorts}
        onChangePopularPortCountry={onChangePopularPortCountry}
        translations={translations}
      />}
      <div className="grid no-gutter">
        <div className="grid-item pr-3" style={{maxHeight: '388px', overflowY: 'auto'}}>
          <div className="mb-4 font-bold">{translations.mostPopular}</div>
          {filteredPorts.map((popularPort, index) =>
            <PopularPort
              key={popularPort.ferryOwnLocationID}
              {...popularPort}
              popularPortClass="px-2"
              isLast={nofPopularPorts - 1 === index}
              onClickPopularPort={onClickPopularPort}
            />
          )}
        </div>
        {queries?.length > 0 && <RecentSearches
          queries={queries}
          onClickQuery={onClickQuery}
          translations={translations}
        />}
      </div>
    </Card>
  );
};

PopularPortOverlay.propTypes = {
  isGreekDeparture: PropTypes.bool,
  popularPorts: PropTypes.object.isRequired,
  queries: PropTypes.object,
  onClickPopularPort: PropTypes.func.isRequired,
  onChangePopularPortCountry: PropTypes.func.isRequired,
  onClickQuery: PropTypes.func,
  translations: PropTypes.shape({
    mostPopular: PropTypes.string.isRequired
  })
};

export default observer(PopularPortOverlay);
